import { InjectionToken } from '@angular/core';
import { LayoutConfig } from '../models/layout.config';

export const LAYOUT_CONFIG_TOKEN = new InjectionToken<LayoutConfig>(
  'LAYOUT_CONFIG'
);
